import { createGlobalStyle, css } from 'styled-components';

import { setScalableFontSize } from './responsive';

const style = css`
  @font-face {
    font-family: 'Cigra';
    src: url('fonts/cigra.eot'); /* IE9 Compat Modes */
    src: url('fonts/cigra.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('fonts/cigra.woff') format('woff'),
      /* Modern Browsers */ url('fonts/cigra.ttf') format('truetype'); /* Safari, Android, iOS */
    font-style: normal;
    font-weight: normal;
    text-rendering: optimizeLegibility;
  }

  html {
    ${setScalableFontSize()};
    overflow: hidden;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    font-size: 24px;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: border-box;
  }
`;

export default createGlobalStyle`
  ${style}
`;
